import { useFetchDashboardData } from '../use-fetch-dashboard';
import { useAverageTaskTimeByNodes } from './charts/use-average-task-time-by-nodes';
import { useEmployeeTasksCount } from './charts/use-employee-tasks-count';
import { useFrequentTasksByNodes } from './charts/use-frequent-tasks-by-nodes';
import { useTasksByHours } from './charts/use-tasks-by-hours';
import { useTasksByRating } from './charts/use-tasks-by-rating';
import { useTasksStatusDistribution } from './charts/use-tasks-by-status';
import { useTasksByWeekday } from './charts/use-tasks-by-week-day';
import { useTasksByZone } from './charts/use-tasks-by-zone';
import { useTasksCategoriesOverTime } from './charts/use-tasks-categories-over-time';
import { useTasksCountOverTime } from './charts/use-tasks-count-over-time';

export const useDashboardTasks = () => {
  useFetchDashboardData([
    'total_tasks_in_time',
    'total_tasks_by_category_in_time',
    'tasks_by_employee',
    'frequent_tasks',
    'tasks_peaks',
    'tasks_daily_load',
    'tasks_by_rating',
    'most_loaded_qrs',
    'tasks_by_status',
  ]);

  return {
    chartsData: [
      useAverageTaskTimeByNodes(),
      useTasksCountOverTime(),
      useTasksCategoriesOverTime(),
      useEmployeeTasksCount(),
      useFrequentTasksByNodes(),
      useTasksByHours(),
      useTasksByWeekday(),
      useTasksByRating(),
      useTasksByZone(),
      useTasksStatusDistribution(),
    ],
  };
};
